import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'
import createResellingService from './ResellingService'
import config from "../config"

const PRODUCT_ID = 'seo_search_atlas'

// Create ResellingService instance using the factory function
const resellingService = createResellingService(config.resellingBaseUrl, PRODUCT_ID)

// Configure request setup
const serviceName = 'SeoResellingService'
const host = servicesConfig.Seo as string
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const SeoResellingService = {
  getProductConfiguration: () => 
    resellingService.getProductConfiguration(),

  getCompanyResellingConfig: (companyId: string) => 
    resellingService.getCompanyResellingConfiguration(companyId),

  updateCompanyResellingConfig: (
    companyId: string,
    data: { amount?: number; offeringEnabled?: boolean }
  ) => resellingService.updateCompanyResellingConfiguration(companyId, data),

  getLocationConfig: (locationId: string) => 
    resellingService.getLocationResellingConfiguration(locationId),

  getLocationSubscriptions: (locationId: string) => 
    resellingService.getLocationSubscriptions(locationId),

  updateLocationResellingConfig: (
    locationId: string,
    data: any
  ) => resellingService.updateLocationResellingConfiguration(locationId, data),

  agencyDirectPurchase: (locationId: string, planId: string, affiliatePayload: any) =>
    resellingService.agencyDirectPurchaseV2(locationId, planId, affiliatePayload),

  getCompanySubscriptions: (companyId: string) => 
    resellingService.getCompanySubscriptions(companyId)
}

export default SeoResellingService
